import {
  AdditionalPointsInfoResponseEnum,
  rbcAdditionalPointsApi,
} from "@b2bportal/rbc-additional-points-api";
import type { FlightContext } from "@checkout/index";
import { getSelectedTripParent } from "@checkout/states/Products/Flight/selectors";
import { FlightSelectors, ParentState } from "@hopper-b2b/checkout";
import axios from "axios";
import { getIsFixedPriceFromBasePrice } from "@/utilities/rewards/pricing";

export const fetchAdditionalPointsPurchaseService = async (
  context: FlightContext,
  _event: unknown
) => {
  const selectedTrip = getSelectedTripParent({ context });

  if (!selectedTrip) {
    throw new Error("No trip selected");
  }

  const travelerInfo = context[ParentState.travelerInformation];
  const seatedPassengers = travelerInfo?.selectedTravelerIds ?? [];
  const lapInfants = travelerInfo?.selectedLapInfantIds ?? [];

  const response = await rbcAdditionalPointsApi(
    axios
  ).apiV0AdditionalPointsInfoPost({
    tripId: selectedTrip.tripId,
    seatedPassengers,
    lapInfants,
  });

  // Return the response regardless of type - Available, NotEligible, or NotNeeded
  return response.data;
};

export const fetchAdditionalPointsPurchaseServiceConditional = async (
  context: FlightContext,
  event: unknown
) => {
  // Check if this is a fixed points purchase flight
  const tripPricing = FlightSelectors.getPricing({
    context,
  });

  const totalPricing = tripPricing?.totalPricing;
  if (!totalPricing?.baseWithoutMargin) {
    return;
  }

  const rewardsAccountId =
    context[ParentState.awardsPayment]?.rewardsAccountId ?? "";

  if (!rewardsAccountId) {
    return;
  }

  const isFixedPrice = getIsFixedPriceFromBasePrice(
    totalPricing.baseWithoutMargin,
    rewardsAccountId
  );

  if (!isFixedPrice) {
    return;
  }

  // If we reach here, it's a fixed points purchase, so fetch additional points
  return fetchAdditionalPointsPurchaseService(context, event);
};
